exports = module.exports = require("../../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2XOzmMGOuO1nA1slkpWf00{max-height:50vh;min-width:550px}html[dir] ._2XOzmMGOuO1nA1slkpWf00{padding:16px 24px 24px}.S4pBKwznFRhCFe5z6xDRc{font-size:21px;font-weight:100;font-weight:200}html[dir] .S4pBKwznFRhCFe5z6xDRc{margin-top:8px;margin-bottom:16px}._7cXBq_Lcyqn4u7vqalJPm{position:absolute;top:12px}html[dir=ltr] ._7cXBq_Lcyqn4u7vqalJPm{right:12px}html[dir=rtl] ._7cXBq_Lcyqn4u7vqalJPm{left:12px}._7cXBq_Lcyqn4u7vqalJPm:hover{color:\"[theme:themeDarker, default:#004578]\"}html[dir] ._3c57Fvb9-GOxD8a2WZ2cw- .ms-MessageBar-icon{margin:8px}html[dir=ltr] ._3c57Fvb9-GOxD8a2WZ2cw- .ms-MessageBar-icon{padding-left:8px}html[dir=rtl] ._3c57Fvb9-GOxD8a2WZ2cw- .ms-MessageBar-icon{padding-right:8px}html[dir] ._3c57Fvb9-GOxD8a2WZ2cw- .ms-MessageBar-text{margin:8px}._1STiSYRLFUftZvjUEjo3fp{font-size:24px}", ""]);

// exports
exports.locals = {
	"container": "_2XOzmMGOuO1nA1slkpWf00",
	"title": "S4pBKwznFRhCFe5z6xDRc",
	"closeButton": "_7cXBq_Lcyqn4u7vqalJPm",
	"errorMessage": "_3c57Fvb9-GOxD8a2WZ2cw-",
	"icon": "_1STiSYRLFUftZvjUEjo3fp"
};